import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Table } from 'rsuite'
import AppContext from '../../../context/AppContext'
import {
  getMasterReviewer,
  getMasterReviewerFileById,
  deleteMasterReviewer,
  getMasterReviewerReport,
} from '../../../redux/actions/masterReviewer'
import '../styles.less'
import ExpertDataTable from './ExpertDataTable'
import { startLoading, doneLoading } from '../../../utils/loading'
import notification from '../../../utils/notification'
import ExpertEditDetailWidget from '../../../widgets/admin/manage/ExpertEditDetailWidget'
import scrollToComponent from 'react-scroll-to-component'
import { downloadFile } from '../../../utils/fileUtil'
import { DEFAULT_ERR_MSG, RETRY_CONTACT_ADMIN } from '../../../constants/msgText'

export default function ExpertAccountSearchAndTableWidget({
  schema: _schema,
  isViewOnly,
  ...props
}) {
  // const contextValue = React.useContext(AppContext)
  // const history = useHistory()
  const [schema, setSchema] = useState(_schema)
  const [isLoading, setIsLoading] = useState(false)
  // const [error, setError] = useState()
  const [loading, setloading] = useState(false)
  const [schemaForEdit, setSchemaForEdit] = useState()
  const [isRefresh, setIsRefresh] = useState(true)
  const [section, setSection] = useState()
  const [expand, setExpand] = useState(true)
  const [showEditPanel, setShowEditPanel] = useState(false)
  // useEffect(() => {
  //   handleGetSchema()
  // }, [])

  // const handleGetSchema = async () => {
  //   setIsLoading(true)
  //   try {
  //     // const response = await getAllProject(5, 1)
  //     // setSchema(response)
  //     setSchema(mockSchema)
  //   } catch (e) {
  //     setError({})
  //   }
  //   setIsLoading(false)
  // }

  const handleOnReload = async (
    pagesize,
    pagenumber,
    firstName,
    lastName,
    idCard,
    accountType,
    expertiseType
  ) => {
    startLoading()
    setloading(true)
    try {
      const response = await getMasterReviewer(
        pagesize,
        pagenumber,
        firstName,
        lastName,
        idCard,
        accountType,
        expertiseType
      )
      // console.log('reload response', response)
      if (response) {
        setSchema(response)
      }
      //setSchema(mockSchemaSearch)
    } catch (e) {
      console.log('e', e)
    }
    setloading(false)
    doneLoading()
  }

  const handleSearchCommittee = async (
    pagesize,
    pagenumber,
    firstName,
    lastName,
    idCard,
    accountType,
    expertiseType
  ) => {
    startLoading()
    setloading(true)
    try {
      const response = await getMasterReviewer(
        pagesize,
        pagenumber,
        firstName,
        lastName,
        idCard,
        accountType,
        expertiseType
      )
      // console.log('search', response)
      if (response) {
        setSchema(response)
      }
      //setSchema(mockSchemaSearch)
    } catch (e) {
      console.log('e', e)
    }
    setloading(false)
    doneLoading()
  }

  const handleOnDownload = async (rowData) => {
    startLoading()
    setloading(true)
    try {
      const fileObj = await getMasterReviewerFileById(rowData.id)
      const url = window.URL.createObjectURL(fileObj)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'หนังสือแต่งตั้ง')
      document.body.appendChild(link)
      link.click()
    } catch (e) {
      console.log('e', e)
      notification.open('error', {
        title: e?.response?.statusText || 'ดาวน์โหลดเอกสารไม่สำเร็จ',
      })
    }
    setloading(false)
    doneLoading()
  }

  const handleOnDelete = async (
    rowData,
    pagesize,
    pagenumber,
    firstName,
    lastName,
    idCard,
    accountType,
    expertiseType
  ) => {
    startLoading()
    setloading(true)
    try {
      const response = await deleteMasterReviewer(rowData.id)
      if (response == 200) {
        handleOnReload(
          pagesize,
          pagenumber,
          firstName,
          lastName,
          idCard,
          accountType,
          expertiseType
        )
      }
    } catch (e) {
      console.log('e', e)
      notification.open('error', {
        title: e?.response?.statusText || 'ลบไม่สำเร็จ ' + RETRY_CONTACT_ADMIN,
      })
    }
    setloading(false)
    doneLoading()
  }

  const handleExportFile = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      const file = await getMasterReviewerReport(request)

      if (file) {
        downloadFile(file, file.name || `ข้อมูลรายการผู้ทรงคุณวุฒิ`)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      // console.log('handleExportFile error : ', e)
      notification.open('error', {
        title: e?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSingleSubmit = (obj) => {
    // console.log('id', obj.ig)
    //history.push(`${pathname.proposal.overview.overviewCoworker}/${obj.id}`)
    // history.push(`${pathname.proposal.overview.overviewCoworker}/mock-reveiw`)
  }

  const handleOnEdit = (rowData) => {
    console.log('rowData', rowData)
    let _schemaForEdit = Object.assign({}, schema.sectionForm)
    let _expertiseType = []
    if (rowData.expertiseType?.length > 0) {
      _expertiseType = rowData.expertiseType.map((item) => {
        return item.value
      })
    }
    _schemaForEdit.hedaer = 'แก้ไขข้อมูลบัญชีผู้ทรงคุณวุฒิ'
    _schemaForEdit.accountType.value = rowData.accountTypeId || ''
    _schemaForEdit.assignNo.value = rowData.assignNo || ''
    _schemaForEdit.bankAccountNo.value = rowData.bankAccountNo || ''
    _schemaForEdit.bankName.value = rowData.bankName || ''
    _schemaForEdit.branchOfBank.value = rowData.branchOfBank || ''
    _schemaForEdit.budgetYear.value = rowData.budgetYear || 0
    _schemaForEdit.effectiveDateEnd.value = rowData.effectiveDateEnd
    _schemaForEdit.effectiveDateStart.value = rowData.effectiveDateStart
    _schemaForEdit.expertiseType.value = _expertiseType || []
    _schemaForEdit.firstName.value = rowData.firstName || ''
    _schemaForEdit.lastName.value = rowData.lastName || ''
    _schemaForEdit.idCard.value = rowData.idCard || ''
    _schemaForEdit.nationality.value = parseInt(rowData.nationality) || 1
    _schemaForEdit.nationality.nationalityOther.value = rowData.nationalityOther || ''
    _schemaForEdit.prefixName.value = rowData.prefixNameId || ''
    _schemaForEdit.reviewType.value = rowData.isReviewOnline ? 2 : 1
    _schemaForEdit.refFile.value = null
    _schemaForEdit.refFilePath = rowData.refFilePath || ''
    _schemaForEdit.id = rowData.id
    _schemaForEdit.personId = rowData.personId

    // console.log('_schemaForEdit', _schemaForEdit)
    setSchemaForEdit(_schemaForEdit)
    setIsRefresh(!isRefresh)

    setShowEditPanel(true)
    setExpand(false)
    scrollToComponent(section, { offset: 1, align: 'top', duration: 500 })
  }

  const onEditSuccess = () => {
    setSchemaForEdit()
    setIsRefresh(!isRefresh)
    setShowEditPanel(false)
    setExpand(true)
  }

  const handleOnCancel = () => {
    setShowEditPanel(false)
    setExpand(true)
  }

  return (
    <>
      {schema && (
        <ExpertDataTable
          schema={schema}
          onSingleSubmit={onSingleSubmit}
          pagination={true}
          onReload={handleOnReload}
          loading={loading}
          hiddenColStatus={true}
          onSearchCommittee={handleSearchCommittee}
          onEdit={handleOnEdit}
          onDownload={handleOnDownload}
          onDelete={handleOnDelete}
          expand={expand}
          isViewOnly={isViewOnly}
          onExport={handleExportFile}
        />
      )}
      <br />
      {/* แก้ไขข้อมูลบัญชีผู้ทรงคุณวุฒิ */}
      <div
        ref={(section) => {
          setSection(section)
        }}
      >
        {schemaForEdit && showEditPanel && (
          <ExpertEditDetailWidget
            schema={schemaForEdit}
            isEditPanel={true}
            editSuccess={onEditSuccess}
            onCancel={handleOnCancel}
          />
        )}
      </div>

      <br />
      <br />
    </>
  )
}
